import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Txt } from "../../components/Txt/Txt";
import styles from "./Box.module.scss";
export const Box = ({ title, children, accent, className = "" }) => {
    return (_jsxs("div", { className: `${styles.box} ${accent ? styles.boxAccent : ""} ${className}`, children: [_jsx(Txt, { className: styles.boxTitle, children: title }), children] }));
};
//# sourceMappingURL=Box.js.map